import React from 'react'
import { T } from '@transifex/react'

export default [
  <T _str="Update container status" />,
  <T _str="Add request (cleaning)" />,
  <T _str="Edit property information" />,
]
